import React from 'react';
import { Table } from 'react-bootstrap';
import LoadingSpinner from '../../../../elements/LoadingSpinner';
import '../RosterScheduler/css/workPatternStyle.css';

const DAY_KEYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const WorkPatternPreview = ({ t, workPatternDetails, isLoading, companyShiftMap }) => {

    if (isLoading) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center wp-preview-placeholder">
                <LoadingSpinner />
            </div>
        );
    }

    if (!workPatternDetails || !workPatternDetails.weeks) return (
        <div className="d-flex flex-column justify-content-center align-items-center wp-preview-placeholder">
            <i className="fa fa-calendar-check-o mb-3 wp-preview-empty-icon"></i>
            <p className="fw-600 text-muted fs14">
                {t('Select a template to preview the work pattern')}
            </p>
        </div>
    );

    return (
        <div className="p-3">
            <div className="border rounded overflow-hidden shadow-sm">

                <div className="d-flex justify-content-between align-items-center p-2 wp-preview-header">
                    <h6 className="fw-700 m-0 text-white wp-preview-title">
                        {workPatternDetails.label}
                        <span className="text-white-50 fw-normal mx-2">|</span>
                        <span className={`badge ms-1 wp-preview-automation-badge ${workPatternDetails.automation ? 'bg-success text-white' : 'bg-white text-dark'}`}>
                            {workPatternDetails.automation ? t('Auto') : t('Manual')}
                        </span>
                    </h6>
                    <span className="badge fw-700 px-3 py-2 wp-preview-weeks-badge">
                        {workPatternDetails.total_weeks} {t('Weeks')}
                    </span>
                </div>

                <div className="table-responsive table-scroll">
                    <Table className="table table-sm mb-0 wp-preview-table">
                        <thead>
                            <tr className="bg-light">
                                <th className="text-center py-2 border-bottom border-top-0 wp-preview-th wp-preview-th--week">
                                    {t('Week')}
                                </th>
                                {DAY_KEYS.map((d) => (
                                    <th key={d} className="text-center py-2 border-bottom border-top-0 wp-preview-th">
                                        {t(d.substring(0, 3))}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody className="bg-white">
                            {workPatternDetails.weeks.map((w, index) => (
                                <tr key={w.week_number} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc' }}>
                                    <td className="text-center align-middle fw-700 border-end wp-preview-week-cell">
                                        {w.week_number}
                                    </td>
                                    {DAY_KEYS.map(d => {
                                        const shift = w.shift_data?.[d];
                                        const shiftInfo = shift ? companyShiftMap.get(shift.shiftCodeId) : null;
                                        const standbyInfo = shift ? companyShiftMap.get(shift.standbyCodeId) : null;
                                        const freeInfo = shift ? companyShiftMap.get(shift.fCodeId) : null;
                                        return (
                                            <td key={d} className="text-center align-middle p-2 border-bottom wp-preview-day-cell">
                                                <div className="d-flex flex-column justify-content-center align-items-center gap-1">
                                                    {shiftInfo ? (
                                                        <div className="d-flex justify-content-center">
                                                            <span
                                                                className="d-inline-flex align-items-center justify-content-center px-2 wp-shift-badge"
                                                                style={{ background: shiftInfo?.shift_color }}
                                                                title={shiftInfo?.name}
                                                            >
                                                                {shiftInfo?.short_code}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <span className="fst-italic text-muted fw-semibold small opacity-75" style={{ height: '33px', lineHeight: '34px' }}>
                                                            {t('free')}
                                                        </span>
                                                    )}
                                                    {standbyInfo ? (
                                                        <div className="d-flex justify-content-center">
                                                            <span
                                                                className="d-inline-flex align-items-end justify-content-center px-2 wp-shift-badge"
                                                                style={{ background: standbyInfo?.shift_color ? standbyInfo?.shift_color : '', height: '33px', lineHeight: '34px' }}
                                                                title={standbyInfo?.name}
                                                            >
                                                                {standbyInfo?.short_code}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                    {freeInfo ? (
                                                        <div className="d-flex justify-content-center">
                                                            <span
                                                                className="d-inline-flex align-items-end justify-content-center px-2 wp-shift-badge"
                                                                style={{ background: freeInfo?.shift_color ? freeInfo?.shift_color : '', height: '33px', lineHeight: '34px' }}
                                                                title={freeInfo?.name}
                                                            >
                                                                {freeInfo?.short_code}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
};

export default WorkPatternPreview;
